import { trigger, state, style, transition, animate, group, query, stagger, keyframes } from '@angular/animations';

export const SlideInOutLeftAnimation = [
  trigger('slideInOutLeft', [
    transition(':enter', [
      style({ transform: 'translateX(100%)', opacity: 0 }),
      animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
    ]),
    transition(':leave', [
      style({ transform: 'translateX(0)', opacity: 1 }),
      animate('200ms', style({ transform: 'translateX(-100%)', opacity: 0 }))
    ])
  ])
];
